import { SplitsAvatar } from '~/components/SplitsAvatar'
import { Tooltip, UserDisplay } from '~/components/component-library'
import {
  AccountSignersCard,
  SignerFacePile,
  getUniqueUserSigners,
} from '~/components/smart-accounts/AccountSigners'
import { OrgMember, OrgSmartAccount } from '~/types'
import { shortenAddress } from '~/utils/addresses'

export const AccountSigners = ({ account }: { account: OrgSmartAccount }) => {
  const userSigners = getUniqueUserSigners(account.signers)
  const orphanSigners = account.signers.filter((signer) => !signer.user)

  if (userSigners.length === 1 && orphanSigners.length === 0) {
    return (
      <div className="max-w-40">
        <UserDisplay
          user={userSigners[0].user as OrgMember}
          layout="standard"
          size="small"
        />
      </div>
    )
  }

  if (userSigners.length > 1) {
    return (
      <Tooltip align="start" content={<AccountSignersCard account={account} />}>
        <SignerFacePile account={account} size={20} />
      </Tooltip>
    )
  }

  return (
    <div className="flex max-w-96 flex-wrap items-center gap-3">
      {userSigners.map((signer) => (
        <div key={signer.user!.id} className="max-w-40">
          <UserDisplay
            user={signer.user as OrgMember}
            layout="standard"
            size="small"
          />
        </div>
      ))}
      {orphanSigners.map((signer) => (
        <span key={signer.id} className="max-w-40 truncate text-sm">
          {signer.displayName ?? signer.name ?? 'Passkey'}
        </span>
      ))}
      {account.eoaSigners.map((signer) => (
        <div
          key={signer.id}
          className="flex max-w-40 items-center gap-2 text-sm text-primary"
        >
          <SplitsAvatar address={signer.address} size={20} />
          <span className="truncate">
            {signer.name || shortenAddress(signer.address)}
          </span>
        </div>
      ))}
    </div>
  )
}
